import { setLocale } from '@/utilities/dateUtils';
import { locale } from '../../constants/global';
import { SET_USER_LANGUAGE_ID } from '../auth/actionTypes';
import UserService from '../users/users.service';
import { SET_LANGUAGE } from './actionTypes';

export const FetchLanguage = (language) => (dispatch) => {
	dispatch({
		type: SET_LANGUAGE,
		language: language,
		messages: locale[language].messages,
	});

	setLocale(locale[language].intl);
};

export const SetLanguage =
	(language, updateUser = true) =>
	(dispatch, getState) => {
		const state = getState();
		const [englishLanguage, spanishLanguage] = state.language.list;
		const languageId = language === 'es_ES' ? spanishLanguage.id : englishLanguage.id;

		dispatch(FetchLanguage(language));

		if (!updateUser) {
			return;
		}

		UserService.update({ id: state.auth.user.id, languageId });
		dispatch({ type: SET_USER_LANGUAGE_ID, languageId });
	};
